// extracted by mini-css-extract-plugin
export var chip = "_5u-9";
export var chipLabel = "_5u-a";
export var close = "_5u-7";
export var closeIcon = "_5u-8";
export var error = "_5u-6";
export var infoTooltip = "_5u-2";
export var innerContainer = "_5u-1";
export var input = "_5u-b";
export var medium = "_5u-5";
export var outerContainer = "_5u-0";
export var small = "_5u-4";
export var xSmall = "_5u-3";